import { Paginacao } from "@/types/paginacao";
import { Decisao } from "./decisao";

export class RetornoListarDecisoes extends Paginacao {
  decisoes: Decisao[];

  constructor(obj?: any) {
    super(obj);
    if (obj)
      this.decisoes = obj.decisoes.map((decisao: any) => new Decisao(decisao));
  }
}
